import type { ChangeEvent, CSSProperties } from 'react';

import { fieldStyle, MONO } from '../venueCreateFields';

interface InputProps {
  value: string;
  onChange: (v: string) => void;
  mono?: boolean;
  placeholder?: string;
  error?: boolean;
  style?: CSSProperties;
  /** Drives the mobile keyboard and the browser's own format check. */
  type?: 'text' | 'tel' | 'email' | 'url';
}

/** Controlled text input for the venue detail-page edit sections, reusing the
 *  create form's field styling. */
export function Input({ value, onChange, mono, placeholder, error, style, type }: InputProps) {
  return (
    <input
      type={type}
      value={value}
      aria-invalid={error || undefined}
      placeholder={placeholder}
      onChange={(e: ChangeEvent<HTMLInputElement>) => onChange(e.target.value)}
      style={fieldStyle(error ? 'error' : undefined, {
        fontFamily: mono ? MONO : undefined,
        ...style,
      })}
    />
  );
}
